import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { LoginResponse } from '@models/swagger';
import { RefreshLoginParams } from './service';

export enum RefreshLoginActions {
  Failure = '[Authentications RefeshLogin] Failure',
  Request = '[Authentications RefeshLogin] Request',
  Success = '[Authentications RefeshLogin] Success',
  Reset = '[Authentications RefeshLogin] Reset',
}

export const RefreshLoginFailure = createAction(RefreshLoginActions.Failure, props<{ error: HttpErrorResponse }>());

export const RefreshLoginRequest = createAction(
  RefreshLoginActions.Request,
  props<{ parameters?: RefreshLoginParams }>()
);

export const RefreshLoginSuccess = createAction(RefreshLoginActions.Success, props<{ data: LoginResponse }>());

export const RefreshLoginReset = createAction(RefreshLoginActions.Reset);
